@if (housekeepingReport.futonSummaries?.length > 0) {
  <p-table
    [value]="housekeepingReport.futonSummaries"
    styleClass="p-datatable-sm"
    [style]="{'font-size':'12px'}">
    <ng-template pTemplate="header">
      <tr>
        <th>Unit</th>
        <th>PickUp</th>
        <th>Drop</th>
        <th>Occupied</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-futonLocation>
      <tr>
        <td>{{ futonLocation.propertyCode }}</td>
        <td>{{ futonLocation.isCheckout ? futonLocation.qty : '' }}</td>
        <td>{{ futonLocation.isCheckin ? futonLocation.qty : '' }}</td>
        <td>{{ futonLocation.isOccupied ? futonLocation.qty : '' }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      <tr>
        <td><strong>Total</strong></td>
        <td>{{ totalPickUp }}</td>
        <td>{{ totalDropOff }}</td>
        <td>{{ totalOccupied }}</td>
      </tr>
    </ng-template>
  </p-table>
}
